module.exports = __webpack_public_path__ + "static/media/female_avatar.31721699.svg";